export default function AddFixedHeaderClassOnScroll($DOM, classes) {
	$DOM.win.scroll(function() {
		$DOM.bodyTag.toggleClass(classes.ShowFixedHeader, $DOM.win.scrollTop() > 10);
	});
}